var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        breadcrumbs: ["Home", "Gifts"],
        guest: _vm.guest,
        review: _vm.review,
        hideFab: "",
        helpForm: false,
        location: _vm.$page.props.auth?.user?.selected_location ?? null,
      },
    },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", md: "10", lg: "8" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "font-weight-bold soli-grey text-h4" },
                    [_vm._v("\n                    Gifts\n                ")]
                  ),
                  _vm._v(" "),
                  _c("v-card-subtitle", [
                    _vm._v(
                      "Give experience and knowledge that will last a\n                    lifetime"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "giftCardForm",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.purchaseGiftCard.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-row",
                            { staticClass: "px-3" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "flex justify-center align-center",
                                  class: _vm.$vuetify.breakpoint.xs
                                    ? null
                                    : "pr-1",
                                  attrs: { cols: "12", sm: "5" },
                                },
                                [
                                  _c("v-img", {
                                    staticClass: "soli-round",
                                    attrs: {
                                      src: [10, 11].includes(
                                        _vm.moment().month()
                                      )
                                        ? "gift-cards-holidays.webp"
                                        : "gift-cards-white.webp",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  class: _vm.$vuetify.breakpoint.xs
                                    ? "pa-0"
                                    : "pl-1",
                                  attrs: { cols: "12", sm: "7" },
                                },
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      staticClass: "w-full",
                                      attrs: { mandatory: "", dense: "" },
                                      model: {
                                        value: _vm.giftCardForm.price,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.giftCardForm,
                                            "price",
                                            $$v
                                          )
                                        },
                                        expression: "giftCardForm.price",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 ma-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-bold soli-grey pa-4",
                                            },
                                            [
                                              _vm._v(
                                                "Select a gift\n                                            amount:"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.options,
                                            function (option) {
                                              return _c(
                                                "v-list-item",
                                                { key: option.amount },
                                                [
                                                  _c("SoliBtn", {
                                                    attrs: {
                                                      block: "",
                                                      text: _vm.formatUnitAmount(
                                                        option.amount
                                                      ),
                                                      value: option,
                                                      color: "soli-grey",
                                                      outlined: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        {
                          staticClass: "my-3",
                          staticStyle: { "max-width": "600px" },
                        },
                        [
                          _vm.$page.props.auth.user
                            ? _c("SoliText", {
                                staticClass: "my-3",
                                attrs: {
                                  errors: _vm.errors.email,
                                  rules: _vm.rules.email,
                                  hideDetails: "",
                                  icon: "alternate_email",
                                  label: "Your email",
                                },
                                model: {
                                  value: _vm.giftCardForm.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.giftCardForm, "email", $$v)
                                  },
                                  expression: "giftCardForm.email",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SoliBtn", {
                            staticClass: "my-3",
                            attrs: {
                              gradient: "gradient-orange",
                              type: "submit",
                              text: "Buy Now",
                              block: "",
                              loading: _vm.giftCardFormLoading,
                              disabled: _vm.$page.props.auth.user
                                ? !_vm.giftCardForm.email
                                : false,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass:
                                "flex justify-center soli-grey mt-1 px-4",
                            },
                            [
                              _vm._v(
                                "Printable certificate, good for services at any\n                            Musicologie location."
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewReceipt !== null
        ? _c(
            "div",
            { staticClass: "soli-round" },
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    fullscreen: _vm.$vuetify.breakpoint.xs ? true : false,
                    "content-class": _vm.$vuetify.breakpoint.xs
                      ? ""
                      : "soli-round",
                    transition: _vm.$vuetify.breakpoint.smAndDown
                      ? "dialog-bottom-transition"
                      : "dialog-transition",
                    "max-width": "600px",
                  },
                  model: {
                    value: _vm.viewReceipt,
                    callback: function ($$v) {
                      _vm.viewReceipt = $$v
                    },
                    expression: "viewReceipt",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "ma-3 soli-close soli-grey soli-text-shadow",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.viewReceipt = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-card-title", [_vm._v("Thank you!")]),
                      _vm._v(" "),
                      _c("v-card-subtitle", [_vm._v("Here's your receipt")]),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { staticClass: "pt-0" },
                        [
                          _vm.successData?.giftCard
                            ? _c(
                                "v-list",
                                [
                                  _c("v-list-item", [
                                    _vm._v(
                                      "\n                            Email: " +
                                        _vm._s(
                                          _vm.successData.giftCard
                                            .customer_email
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            Amount:\n                            " +
                                        _vm._s(
                                          _vm.formatUnitAmount(
                                            _vm.successData.giftCard.amount
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            Payment: " +
                                        _vm._s(_vm.successData.giftCard.last4) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            Redemption Code:\n                            " +
                                        _vm._s(_vm.successData.giftCard.code)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("v-img", {
                                    attrs: {
                                      src: _vm.successData.giftCard.img_url,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }